import * as React from "react";

import { Icon } from "../../../Icons/Icon";
import { TestPageObjectHandle } from "../../../Services/TestPageObjects/TestPageObjectHandle";

import { Root } from "./TableCellPencil.styles";

interface TableCellPencilProps {
    groupKey: string;
    onClick?: () => void;
}

export function TableCellPencil(props: TableCellPencilProps): JSX.Element {
    return (
        <TestPageObjectHandle
            id={`TableCellPencil/${props.groupKey}`}
            pageObject={{
                getType: () => "TableCellPencil",
                click: () => (props.onClick !== undefined ? props.onClick() : null),
            }}>
            <Root onClick={props.onClick}>
                <Icon name="ToolPencilLineIcon" />
            </Root>
        </TestPageObjectHandle>
    );
}
